import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ReorderQuestionsUseCaseInterface } from 'domain/usecases';

export class RemoteReorderQuestions
  implements ReorderQuestionsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: ReorderQuestionsUseCaseInterface.Params,
  ): Promise<ReorderQuestionsUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/reorder`,
      body: params,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
